export default __webpack_public_path__ + "static/media/oval-loader.e6a71ca5.svg";